import { PICOS, faixas, horas, sobreposicao, totalMin } from "../lib/horarios";

/** Horas abertas na semana e quanto delas cobre os picos de almoço e jantar. */
export default function Desempenho({ dias }) {
  const lista = dias.map(faixas);
  const total = lista.reduce((t, f) => t + totalMin(f), 0);
  const cards = [
    { rotulo: "Horas totais na semana", valor: horas(total) },
    ...PICOS.map((p) => ({
      rotulo: `No pico de ${p.nome} | ${p.de} às ${p.ate}h`,
      valor: horas(lista.reduce((t, f) => t + sobreposicao(f, p.de * 60, p.ate * 60), 0)),
      detalhe: `de ${horas((p.ate - p.de) * 60 * 7)} possíveis na semana`,
    })),
  ];
  return (
    <section className="space-y-2" data-e2e="desempenho-horarios">
      <h2 className="text-[17px] font-semibold">Desempenho</h2>
      <div className="grid gap-2 rounded-2xl bg-muted/60 p-2 md:grid-cols-3">
        {cards.map((c) => (
          <div key={c.rotulo} className="rounded-xl border bg-card px-4 py-3">
            <span className="block text-[13px] text-muted-foreground">{c.rotulo}</span>
            <b className="block text-[19px] font-semibold mt-px tabular-nums">{c.valor}</b>
            {c.detalhe && <small className="block text-xs text-muted-foreground/80 mt-0.5">{c.detalhe}</small>}
          </div>
        ))}
      </div>
    </section>
  );
}
